import { NavIcons } from "assets/icons";
import { ResellerLevel } from "modules/resellers";

import { Route } from "../common.types";
import { ModeratorRoutesPrivileges } from "./enums";

export const Routes: Route[] = [
  {
    label: "Dashboard",
    icon: <NavIcons.DashboardIcon />,
    path: "/",
    privilege: ModeratorRoutesPrivileges.Dashboard,
  },
  {
    label: "Users",
    icon: <NavIcons.ResellersIcon />,
    path: "/users",
    nestedRoutes: [
      { label: "All", path: "/users/all" },
      { label: "Buyer", path: `/users/${ResellerLevel.Buyer}` },
      { label: "Reseller", path: `/users/${ResellerLevel.IncompleteReseller}` },
      { label: "Beginner", path: `/users/${ResellerLevel.BeginnerReseller}` },
      {
        label: "Intermediate",
        path: `/users/${ResellerLevel.IntermediateReseller}`,
      },
      { label: "Confirmed", path: `/users/${ResellerLevel.ConfirmedReseller}` },
      { label: "Influencer", path: `/users/${ResellerLevel.Influencer}` },
    ],
    hideNestedRoutes: true,
    privilege: ModeratorRoutesPrivileges.Resellers,
  },
  {
    label: "Categories",
    icon: <NavIcons.CategoriesIcon />,
    path: "/categories",
    privilege: ModeratorRoutesPrivileges.Categories,
  },
  {
    label: "Orders",
    icon: <NavIcons.OrdersIcon />,
    path: "/orders",
    privilege: ModeratorRoutesPrivileges.Orders,
  },
  {
    label: "Returns",
    icon: <NavIcons.ReturnsIcon />,
    path: "/returns",
    privilege: ModeratorRoutesPrivileges.Returns,
  },
  {
    label: "Products",
    icon: <NavIcons.ProductsIcon />,
    path: "/products",
    privilege: ModeratorRoutesPrivileges.Products,
  },
  {
    label: "Product Sets",
    icon: <NavIcons.ProductsListsIcon />,
    path: "/product-sets",
    privilege: ModeratorRoutesPrivileges.ProductSets,
  },
  {
    label: "Packs",
    icon: <NavIcons.ProductsListsIcon />,
    path: "/packs",
    privilege: ModeratorRoutesPrivileges.Products,
  },
  {
    label: "Special Offers",
    icon: <NavIcons.OffersIcon />,
    path: "/offers",
    privilege: ModeratorRoutesPrivileges.SpecialOffers,
  },
  {
    label: "Banners",
    icon: <NavIcons.BannersIcon />,
    path: "/banners",
    privilege: ModeratorRoutesPrivileges.Banners,
  },
  {
    label: "Coupons",
    icon: <NavIcons.CouponsIcon />,
    nestedRoutes: [
      {
        label: "Bonus Coupons",
        path: "/bonus-coupons",
        nestedRoutes: [
          { label: "Sharings", path: "/bonus-coupons/sharings" },
          { label: "Qty Resold", path: "/bonus-coupons/qty-resold" },
          {
            label: "Value Resold",
            path: "/bonus-coupons/value-resold",
          },
          {
            label: "Orders Resold",
            path: "/bonus-coupons/orders-resold",
          },
          {
            label: "Custom",
            path: "/bonus-coupons/custom",
          },
        ],
      },
      { label: "Spend & Save Coupons", path: "/spend-and-save-coupons" },
      { label: "Influencer Coupons", path: "/influencer-coupons" },
    ],
    privilege: ModeratorRoutesPrivileges.Coupons,
  },
  {
    label: "Sharing Schedule",
    icon: <NavIcons.SharingScheduleIcon />,
    path: "/sharing",
    privilege: ModeratorRoutesPrivileges.SharingSchedule,
  },
  {
    label: "Insights",
    icon: <NavIcons.InsightsIcon />,
    nestedRoutes: [
      { label: "Price Insights", path: "/insights/price-insights" },
      { label: "Inventory Insights", path: "/insights/inventory-insights" },
      { label: "Never Sold", path: "/insights/never-sold" },
    ],
    privilege: ModeratorRoutesPrivileges.Insights,
  },
  {
    label: "Marketing",
    icon: <NavIcons.NotificationIcon />,
    nestedRoutes: [
      { label: "Contacts", path: "/marketing/contacts" },
      { label: "Templates", path: "/marketing/templates" },
      { label: "Campaigns", path: "/marketing/campaigns" },
      { label: "Flows", path: "/marketing/flows" },
    ],
    privilege: ModeratorRoutesPrivileges.Marketing,
  },
  {
    label: "Recommendations",
    icon: <NavIcons.ProductsListsIcon />,
    nestedRoutes: [
      { label: "Affinity Graph", path: "/recommendations/affinity" },
      { label: "Enrichment", path: "/recommendations/enrichment" },
      { label: "Enrichment Rules", path: "/recommendations/profiles" },
      { label: "Cross-sell Discount", path: "/recommendations/discount" },
    ],
    privilege: ModeratorRoutesPrivileges.Products,
  },
  {
    label: "Inventory",
    icon: <NavIcons.InventoryIcon />,
    nestedRoutes: [
      { label: "Managers", path: "/inventory/managers" },
      { label: "QRs", path: "/inventory/qrs" },
      { label: "Damaged Items", path: "/inventory/damaged-items" },
      { label: "Missing Items", path: "/inventory/missing-items" },
      { label: "Warehouses", path: "/inventory/warehouses" },
    ],
    privilege: ModeratorRoutesPrivileges.Inventory,
  },
  {
    label: "Transfers",
    icon: <NavIcons.InventoryIcon />,
    path: "/warehouse/transfers",
    privilege: ModeratorRoutesPrivileges.Inventory,
  },
  {
    label: "Financial",
    icon: <NavIcons.FinancialIcon />,
    nestedRoutes: [
      {
        label: "Earnings",
        path: "/earnings",
        nestedRoutes: [
          { label: "Pending", path: "/earnings/Pending" },
          { label: "Ready to Pay", path: "/earnings/AvailableToBePaid" },
          { label: "Paid", path: "/earnings/Paid" },
          { label: "Canceled", path: "/earnings/Canceled" },
        ],
      },
      { label: "Delivery Fees", path: "/delivery-fees/fees" },
      { label: "Transactions", path: "/transactions" },
      { label: "Internal Bank", path: "/internal-bank" },
      { label: "Deliveries", path: "/deliveries" },
      { label: "Profit and Loss", path: "/profit-and-loss" },
      { label: "Refunds", path: "/refunds" },
    ],
    privilege: ModeratorRoutesPrivileges.Financial,
  },
  {
    label: "Notification",
    icon: <NavIcons.NotificationIcon />,
    path: "/notification",
    privilege: ModeratorRoutesPrivileges.Notification,
  },
  {
    label: "Verification",
    icon: <NavIcons.VerificationIcon />,
    path: "/verification",
    privilege: ModeratorRoutesPrivileges.Verification,
  },
  {
    label: "Individual Drivers",
    icon: <NavIcons.IndividualDriverIcon />,
    path: "/drivers",
    privilege: ModeratorRoutesPrivileges.Drivers,
    sectionLabel: "Logistics",
  },
  {
    label: "Companies",
    icon: <NavIcons.CompaniesIcon />,
    path: "/companies",
    privilege: ModeratorRoutesPrivileges.Drivers,
  },
  {
    label: "Delivery Priority",
    icon: <NavIcons.DeliveryPriorityIcon />,
    path: "/delivery-priority",
    privilege: ModeratorRoutesPrivileges.Drivers,
  },
  {
    label: "Delivery Rules",
    icon: <NavIcons.DeliveryRulesIcon />,
    path: "/delivery-rules",
    privilege: ModeratorRoutesPrivileges.Drivers,
  },
  {
    label: "AI Agents",
    icon: <NavIcons.AIAgentsIcon />,
    path: "/ai/agents",
    privilege: ModeratorRoutesPrivileges.AiAssistants,
    sectionLabel: "AI",
  },
  {
    label: "Conversations",
    icon: <NavIcons.ConversationsIcon />,
    path: "/ai/conversations",
    privilege: ModeratorRoutesPrivileges.AiAssistants,
  },
  {
    label: "To review",
    icon: <NavIcons.VerificationIcon />,
    path: "/ai/review",
    privilege: ModeratorRoutesPrivileges.AiAssistants,
  },
  {
    label: "Support",
    icon: <NavIcons.SupportIcon />,
    path: "/ai/support",
    privilege: ModeratorRoutesPrivileges.AiAssistants,
  },
  {
    label: "AI Tickets",
    icon: <NavIcons.AITicketsIcon />,
    path: "/ai/tickets",
    privilege: ModeratorRoutesPrivileges.AiAssistants,
  },
  {
    label: "Ad Mappings",
    icon: <NavIcons.OffersIcon />,
    path: "/ai/ad-products",
    privilege: ModeratorRoutesPrivileges.AiAssistants,
  },
  {
    label: "Content",
    icon: <NavIcons.ContentIcon />,
    path: "/content",
    nestedRoutes: [
      { label: "Privacy & Terms", path: "/content/privacy" },
      { label: "About Us", path: "/content/about" },
      { label: "Social", path: "/content/social" },
      { label: "FAQ", path: "/content/faq" },
      { label: "Video", path: "/content/video" },
      { label: "Quiz", path: "/content/quiz" },
      { label: "Info Bar", path: "/content/info-bar" },
      { label: "Feed", path: "/content/feed" },
      { label: "Announcements", path: "/content/announcements" },
    ],
    hideNestedRoutes: true,
    privilege: ModeratorRoutesPrivileges.Content,
    sectionLabel: "System",
  },
  {
    label: "Staff Management",
    icon: <NavIcons.StaffIcon />,
    path: "/staff",
    privilege: ModeratorRoutesPrivileges.StaffManagement,
  },
  {
    label: "Activity Log",
    icon: <NavIcons.ContentIcon />,
    path: "/activity-log",
    privilege: ModeratorRoutesPrivileges.ActivityLog,
    sectionLabel: "Security",
  },
  {
    label: "Critical Alerts",
    icon: <NavIcons.NotificationIcon />,
    path: "/audit-alerts",
    privilege: ModeratorRoutesPrivileges.CriticalAlerts,
  },
  {
    label: "Email Notifications",
    icon: <NavIcons.SettingsIcon />,
    path: "/email-notifications",
    privilege: ModeratorRoutesPrivileges.EmailNotifications,
  },
];
